var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import config from 'app/config';
import moment from 'moment';
import { VIDEO_VENDORS } from '../vendors';
const CHANNELS = [1, 2, 3, 4, 5, 6, 7, 8, 9].map((id) => ({
    id,
    label: `Камера ${id}`,
}));
const LIVE_PORT = 12060;
const ARCHIVE_PORT = 8090;
const ARCHIVE_WINDOW_SECONDS = 120;
const EVENT_LABELS = {
    1: 'Сигнал потери видео',
    2: 'Датчик движения',
    3: 'Сигнал закрывающий камеру',
    4: 'Ошибка хранилища',
    5: 'IO1',
    6: 'IO2',
    7: 'IO3',
    8: 'IO4',
    9: 'IO5',
    10: 'IO6',
    11: 'IO7',
    12: 'IO8',
    13: 'Аварийный сигнал',
    14: 'Сигнал низкой скорости',
    15: 'Сигнал высокой скорости',
    16: 'Низкое напряжение',
    17: 'Сигнал ускорения',
    18: 'Геозона',
    19: 'Аномалия запуска',
    20: 'Недейтвительное отключение',
    29: 'Датчик температуры',
    36: 'Сигнал о столкновении',
    38: 'Покидание полосы',
    47: 'Аномальное изменение температуры',
    58: 'Вождение в усталом состоянии',
    59: 'Отсутствие водителя',
    60: 'Вызов водителя',
    61: 'Водитель курит',
    62: 'Отвлечение водителя',
    63: 'DSM Покидание полосы',
    64: 'DSM Сигнал о столкновении',
    74: 'Аномальное отключение панели',
    81: 'Датчик холостого хода дверной сигнализации',
    160: 'Сигнализация превышения скорости',
    161: 'Распознавание номерных знаков',
    162: 'Расстояние слишком близко',
};
function mediaHost() {
    return config.mapBroadcastUrl;
}
function previewPort(channelId) {
    const channel = Number(channelId);
    if (channel <= 3) {
        return 61;
    }
    if (channel <= 6) {
        return 62;
    }
    return 63;
}
function liveUrl(deviceId, channelId) {
    return `${mediaHost()}:${LIVE_PORT}/live.flv?devid=${deviceId}&chl=${channelId}&st=1&audio=0`;
}
function previewUrl(deviceId, channelId) {
    return `${mediaHost()}:120${previewPort(channelId)}/live.flv?devid=${deviceId}&chl=${channelId}&st=1&audio=0`;
}
function archiveUrl(params) {
    const startTime = params.positionSeconds !== 0 ? moment.utc((params.positionSeconds - ARCHIVE_WINDOW_SECONDS) * 1000).format('HHmmss') : '000000';
    const endTime = params.positionSeconds !== 0 ? moment.utc((params.positionSeconds + ARCHIVE_WINDOW_SECONDS) * 1000).format('HHmmss') : '000400';
    const startDate = moment(params.selectedDate[0]).format('YYYYMMDD');
    const endDate = moment(params.selectedDate[1]).format('YYYYMMDD');
    return `${mediaHost()}:${ARCHIVE_PORT}/play/${params.deviceId}/${params.channelId}/${startDate}${startTime}_${endDate}${endTime}_main.m3u8`;
}
export const streamaxAdapter = {
    vendor: VIDEO_VENDORS.STREAMAX,
    supportsPreviewStreams: true,
    supportsArchive: true,
    requiresFlvJs: true,
    getChannels() {
        return CHANNELS;
    },
    getLivePlayback(params) {
        return __awaiter(this, void 0, void 0, function* () {
            return {
                kind: 'flv',
                isLive: true,
                url: liveUrl(params.deviceId, params.channelId),
            };
        });
    },
    getArchivePlayback(params) {
        return __awaiter(this, void 0, void 0, function* () {
            return {
                kind: 'hls',
                isLive: false,
                url: archiveUrl(params),
            };
        });
    },
    getPreviewPlayback(params) {
        return __awaiter(this, void 0, void 0, function* () {
            return {
                kind: 'flv',
                isLive: false,
                url: previewUrl(params.deviceId, params.channelId),
            };
        });
    },
    getEventLabel(type) {
        return EVENT_LABELS[Number(type)] || String(type);
    },
};
